export default __webpack_public_path__ + "locales/ja-JP/Common.json?hash=a127e4c9fae861b89a98dfff8f59cf0a";